import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import type {
  InvoiceTemplate,
  InvoiceTemplateSource,
  UpdateInvoiceTemplateInput,
} from '@catalyst-psa/shared';

import { api } from '../../api/client.js';

const templateKeys = {
  all: ['invoice-templates'] as const,
  detail: (source: InvoiceTemplateSource) => ['invoice-templates', source] as const,
};

export function useInvoiceTemplates(): UseQueryResult<InvoiceTemplate[]> {
  return useQuery({
    queryKey: templateKeys.all,
    queryFn: () => api.get<InvoiceTemplate[]>('/invoice-templates'),
  });
}

export interface UpdateInvoiceTemplateArgs {
  source: InvoiceTemplateSource;
  input: UpdateInvoiceTemplateInput;
}

export function useUpdateInvoiceTemplate(): UseMutationResult<
  InvoiceTemplate,
  unknown,
  UpdateInvoiceTemplateArgs
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ source, input }: UpdateInvoiceTemplateArgs) =>
      api.put<InvoiceTemplate>(`/invoice-templates/${source}`, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: templateKeys.all });
    },
  });
}
